/**
 * Resucers Filter
 */
import { combineReducers } from "redux";

// Import custom components
import productReducer from "./products";
import filtersReducer from "./filters";
import userReducer from "./user";

const rootReducer = combineReducers({
  data: productReducer,
  filters: filtersReducer,
  user: userReducer,
});

export default rootReducer;
